module.exports = __webpack_public_path__ + "static/img/login_image.08a2ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zlkindex/login_image.png
// module id = //0i
// module chunks = 1